import React from 'react'
import { Card, Flex } from 'antd'
import _ from 'lodash'
import Title from 'antd/es/typography/Title'
import { PieChart } from '@mui/x-charts'

export default function PatientOriginChart ({ slots }) {
  const format = (places, place) => {
    return { id: place, value: places[place].length, label: place }
  }

  const postalPlaces = _.groupBy(slots, (slot) => {
    if (slot.postal_place) {
      return `${slot.postal_place.name} (${slot.postal_place.zip_code})`
    } else {
      return 'Inconnu'
    }
  })

  return (
    <Card>
      <Flex vertical>
        <Title level={5} style={{ textAlign: 'center' }}>
          {'Provenance des patients'}
        </Title>
        <PieChart series={[
          {
            data: Object.keys(postalPlaces).map((day) => (format(postalPlaces, day))),
            cornerRadius: 3,
            arcLabelRadius: 160
          }
        ]} width={300} height={300} hideLegend />
      </Flex>
    </Card>
  )
}
